import * as THREE from "three";

import simulationFragShader from "./glsl/simulationFrag.glsl?raw";
import simulationVertShader from "./glsl/simulationVert.glsl?raw";
import displayFragShader from "./glsl/displayFrag.glsl?raw";
import displayVertShader from "./glsl/displayVert.glsl?raw";
import passthroughVertShader from "./glsl/passthroughVert.glsl?raw";
import passthroughFragShader from "./glsl/passthroughFrag.glsl?raw";
import maskInjectFragShader from "./glsl/maskInjectFrag.glsl?raw";

import { simulationUniforms, displayUniforms, passthroughUniforms } from "./uniforms";

export const simulationMaterial = new THREE.ShaderMaterial({
  uniforms: simulationUniforms,
  vertexShader: simulationVertShader,
  fragmentShader: simulationFragShader,
});
simulationMaterial.blending = THREE.NoBlending;

export const displayMaterial = new THREE.ShaderMaterial({
  uniforms: displayUniforms,
  vertexShader: displayVertShader,
  fragmentShader: displayFragShader,
  extensions: { derivatives: true },
});
displayMaterial.blending = THREE.NoBlending;

export const passthroughMaterial = new THREE.ShaderMaterial({
  uniforms: passthroughUniforms,
  vertexShader: passthroughVertShader,
  fragmentShader: passthroughFragShader,
});
passthroughMaterial.blending = THREE.NoBlending;

export const maskInjectMaterial = new THREE.ShaderMaterial({
  uniforms: {
    previousIterationTexture: simulationUniforms.previousIterationTexture,
    maskTexture: { value: null },
  },
  vertexShader: passthroughVertShader,
  fragmentShader: maskInjectFragShader,
});
maskInjectMaterial.blending = THREE.NoBlending;
